module.exports = __webpack_public_path__ + "img/logo_facebook.57641947.png";